export const UPDATE_NAME_SERVICE = 'UPDATE_NAME_SERVICE';
export const updateNameService = q => ({
  type: UPDATE_NAME_SERVICE,
  payload: q
});
